module.exports = __webpack_public_path__ + "static/img/product-swipe35.66c51686.png";